// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"d79da54e","287":"13ae6267","340":"972e7d4d","517":"135618ef","523":"0b612fcc","702":"0cc02ddf","790":"cf6aa996","859":"c3fb2a1a","941":"239f40a4"}[chunkId] + ".chunk.css";
};